@if (stageCount > 0) {
  <!-- STAGE-MARKERS -->
  <ul class="container">
    @for (
      stage of stages; track
      stage; let i = $index; let first = $first; let last = $last) {
      <li
        class="stage"
        (click)="changeStage(i, stage)"
        [style.left]="padLeft(i, first, last)"
      [ngClass]="{
        active: markAllComplete || i <= latestIndex,
        current: stage === current,
        first: first,
        last: last
      }"
        >
        <div class="stage-marker">
          <div class="stage-circle-wrapper"><div class="stage-circle"></div></div>
        </div>
        <div class="stage-label body-bold">{{ stage }}</div>
      </li>
    }
  </ul>
  <!-- PROGRESS BAR -->
  <div class="progress-bar">
    <div
      class="progress"
      [style.transform]="'translateX(' + progress + '%)'"
    ></div>
  </div>
}
